package com.tovtalk.domain.entity

import com.tovtalk.utils.strings.StringProvider

/**
 * Returns the display name for this kashrut level.
 * Uses server-provided translation if set, falls back to bundled JSON via StringProvider.
 */
fun KosherLevel.resolvedName(currentLang: String): String =
    if (currentLang.startsWith("he")) nameHe ?: StringProvider.get(nameKey)
    else nameEn ?: StringProvider.get(nameKey)
